module.exports = __webpack_public_path__ + "img/seejc_cover.4a21d9a3.png";